const authInitialState = {
  auth: false,
  authAttempted: false,
  authedUserId: null,
};

export default authInitialState;
